// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__Sr-r3","checkbox":"Checkbox_checkbox__utDNY","checked":"Checkbox_checked__lIiRD"};